import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

const ProofStatusPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const status = location.state?.status || "approve";
  const isApproved = status === "approve";

  const title = isApproved ? "Proof has been Approved" : "Proof has been Rejected";
  const message = "THANK YOU!";

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f5f5f5",
        textAlign: "center",
        p: 3,
      }}
    >
      <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
        {title}
      </Typography>
      <Typography variant="h6" sx={{ mb: 4 }}>
        {message}
      </Typography>

      {/* <Button
        variant="contained"
        color="primary"
        onClick={() => navigate("/")} 
      >
        Go Home
      </Button> */}
    </Box>
  );
};

export default ProofStatusPage;
